import { PeoplePageQueryDispatch, PeoplePageQueryState } from '../customPeopleTagTypes';

import { useQueryState } from './useQueryState';

export const usePeoplePageSearchState = (): [PeoplePageQueryState, PeoplePageQueryDispatch] => (
  useQueryState<PeoplePageQueryState>()
);
